window.addEventListener('load', () => {
  const marquees = document.querySelectorAll('.marquee');

  if (!marquees || marquees.length === 0) return;

  marquees.forEach((marquee) => {
    const headings = marquee.querySelectorAll("h2");

    if (headings.length > 0) {
      const firstHeading = headings[0];

      // 🔹 Remove all duplicates
      headings.forEach((el, index) => {
        if (index !== 0) el.remove();
      });

      // 🔹 Stop animation (do NOT run animate function)
      // (we simply don't call requestAnimationFrame)

      // 🔹 Reset styles applied by animation
      firstHeading.style.marginLeft = "0px";

      // 🔹 Center align
      marquee.style.display = "flex";
      marquee.style.justifyContent = "center";
      marquee.style.alignItems = "center";

      firstHeading.style.margin = "0";
      firstHeading.style.textAlign = "center";
    }
  });
});